"use client";

import { useLocale } from "@calcom/lib/hooks/useLocale";
import { useTenantBranding } from "@calcom/lib/tenantBrandingContext";
import classNames from "@calcom/ui/classNames";

/**
 * The tenant's legal links (privacy policy and imprint), which Miragon's tools show at the bottom left instead of
 * upstream's "© Cal.com, Inc." credit (Miragon fork, see FORK_CHANGES.md and tenantBranding.ts).
 */
export function TenantLegalLinks({ className }: { className?: string }) {
  const { t } = useLocale();
  const { privacyPolicyUrl, imprintUrl } = useTenantBranding();
  const linkClassName = "underline underline-offset-2 hover:decoration-2";

  return (
    <nav
      aria-label={t("legal_links")}
      className={classNames("flex flex-wrap gap-x-4 gap-y-1 text-xs", className)}>
      <a href={privacyPolicyUrl} target="_blank" rel="noopener noreferrer" className={linkClassName}>
        {t("privacy_policy")}
      </a>
      <a href={imprintUrl} target="_blank" rel="noopener noreferrer" className={linkClassName}>
        {t("imprint")}
      </a>
    </nav>
  );
}
